import React, { useState } from 'react';
import { useHistory } from 'react-router';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';

export interface UserInputDictionary
{
  [key: string]: string,
}

interface Props
{
  userInput: UserInputDictionary,
  saveUserInput: (input: UserInputDictionary) => void,
}

export const CreateForm: React.FC<Props> = ({userInput, saveUserInput}: Props) =>
{
  const [name, setName] = useState(userInput['name'] || '');
  const [description, setDescription] = useState(userInput['description'] || '');
  const history = useHistory();

  const { uiStore, featureStore } = useStore();
  const createFeatureHandler = async () =>
  {
    saveUserInput({"name": name, "description": description});
    await featureStore.createAsync(name, description);
    if (!featureStore.isError)
    {
      const featureToken = featureStore.feature?.token || '';
      history.push(paths.buildFeatureViewPath(featureToken));
    }
  };
  const cancelHandler = () =>
  {
    featureStore.clearError();
    history.goBack();
  }
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.feature.name.label}:
          <input type="text" placeholder={uiStore.labels.common.forms.feature.name.placeholder} value={name} onChange={e => setName(e.target.value)} />
        </label>
        <label>
          {uiStore.labels.common.forms.feature.description.label}:
          <input type="text" placeholder={uiStore.labels.common.forms.feature.description.placeholder} value={description} onChange={e => setDescription(e.target.value)} />
        </label>
      </div>

      <div className="actions">
        <button onClick={createFeatureHandler}>{uiStore.labels.common.forms.create}</button>
        <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
      </div>
    </>
  );
}